"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _notification = require("@widget/notification");

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Message = _interopRequireDefault(require("./Message"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function List() {
  try {
    var items = (0, _reactRedux.useSelector)(_notification.selectItems);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['wrapper']
    }, items.map(function (message) {
      return /*#__PURE__*/_react["default"].createElement(_Message["default"], {
        key: message['id'],
        subject: message['subject'],
        body: message['body'],
        date: message['creationDate']
      });
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = List;
exports["default"] = _default;